export default {"src":"/_next/static/media/logo.262d8190.svg","height":69,"width":164};